module.exports = __webpack_public_path__ + "static/media/icon-calendar-alarm.392121ae.png";